(function($, d, g) {

    'use strict';
    var showMoreBtn;
    var filterBtn;
    var toggleAccountBtn;
    var toggleProfileBtn;
    var submitManualOperationBtn;
    var confirmForm;
    var deleteUserBtn;
    var deleteUserProfileBtn;
    var toggleServiceFeesBtn;
    var toggleAuto;
    
    var confirmAction = function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
        }
    };
    
    var toggleDisplayElements = function() {
        var btn = $(this),
            sel = btn.parent().find(btn.attr("data-selectors"));
            
        if (btn.hasClass("active")) {
            sel.addClass("hide");
            btn.removeClass("active");
        } else {
            sel.removeClass("hide");
            btn.addClass("active");
        }
    };
    
    var detectLanding = function() {
        if (d.querySelector(".account-login-landing")) {
            d.querySelector(".open-login-btn").click();
        }
    };
    
    var submitFilter = function(){
      $(this).closest('form').submit();  
    };
    
    var toggleAccountActivation = function(){
        var t = $(this);
        var action = t.hasClass("toggle-account-disabled");
        var activate = (action) ? "account-validated" : "disabled";
        var deleteAction = t.closest('.users-table-actions-ctn').find('.table-delete-action');
        
        var urlSuspend = "/action/epSuspendAccount";
        urlSuspend += "?id="+t.attr("data-id");
        urlSuspend += "&suspend="+ !action;
        urlSuspend += "&ajax=true";
        
        ajax(urlSuspend, function(){
            if(action){
                t.removeClass("toggle-account-disabled");
                t.find("p").html(t.attr("data-deactivate"));
                deleteAction.addClass('hide');
            }
            else{
                t.addClass("toggle-account-disabled"); 
                t.find("p").html(t.attr("data-activate"));
                deleteAction.removeClass('hide');
            }
        }, true);
    };
    
    var toggleProfileActivation = function(){
        var t = $(this);
        var activate = t.hasClass("toggle-profile-disabled");
        
        var urlSuspend = "/action/epSuspendAccount";
        urlSuspend += "?profileId="+t.attr("data-id");
        urlSuspend += "&suspend="+ !activate;
        urlSuspend += "&ajax=true";
        
        ajax(urlSuspend, function(response){
            if(activate){
                t.removeClass("toggle-profile-disabled");
                t.find("p").html(t.attr("data-deactivate"));
            }
            else{
                t.addClass("toggle-profile-disabled"); 
                t.find("p").html(t.attr("data-activate"));

            }
        }, true);
    };

    var submitManOpForm = function() {
        var t = $(this);
        var form = t.closest('.js-form');
        var amount  = $('input[name="amt"]', form);
        var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', form);

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            t.addClass('disabled');
            
            if (parseFloat(amount.val()) <= 0) {
                t.removeClass("disabled");
                zeroOrUnderError.slideDown();
            } else {
                zeroOrUnderError.slideUp();
                var profileId = $('input[name="profileId"]', form);
                var type;
                var typeChoiceInputs = form.find('input[name="balance-choice-' + profileId.val() + '"]');
                typeChoiceInputs.each(function() {
                    if ($(this).prop('checked') === true) {
                        type = $(this).val();
                    }
                });
                var positive  = $('select[name="positive"]', form);
                var comment  = $('textarea[name="comment"]', form);

                var url = '/action/epUpdateBalance';
                url += '?profileId=' + profileId.val();
                url += '&type=' + type;
                url += '&positive=' + positive.val();
                url += '&amt=' + amount.val();
                url += '&comment=' + encodeURIComponent(comment.val());
                url += '&ajax=true';

                ajax(url,function (response) {
                    t.removeClass('disabled');
                    
                    if (response.indexOf('fail') !== -1) {
                        form.find('.js-form-error-message.fail-msg').slideDown(function() {
                            setTimeout(function() {
                                $(this).slideUp();
                            }, 5000);
                        });
                    } else {
                        t.closest('.popup-ctn').find('.popup-inner-close').trigger('click');
                        form.find('input[type=number], select, textarea').val('').removeClass('success');
                        form.find('.input-ctn').removeClass('focused');

                        var balanceOwing = fixNum(response.split('*')[1]);
                        var balanceOwingTd = t.closest('tr').find('.balance-owing-to-epass').find('p');
                        var balanceOwed = fixNum(response.split('*')[0]);
                        var balanceOwedTd = t.closest('tr').find('.balance-owed-to-profile').find('p');
                        var lang = $('input#lang').val();

                        if (lang === 'fr') {
                            balanceOwingTd.html(balanceOwing + '$');
                            balanceOwedTd.html(balanceOwed + '$');
                        } else {
                            balanceOwingTd.html('$ ' + balanceOwing);
                            balanceOwedTd.html('$ ' + balanceOwed );
                        }
                    }
                },true);
            }
        }
    };

    var fixNum = function(x, n) {
        var m = n ? n : 2;
        var y = parseFloat(x);
        if (y < 0) {
            return Math.abs(y).toFixed(m) * -1;
        } else {
            return y.toFixed(m);
        }
    };
    
    var deleteUser = function(e) {
        confirmForm = $(this).closest("form")[0];
        $("#user_account_prompt_delete .popup-inner-content-btn .btn")
                .click(confirmAction);
        openWindow("user_account_prompt_delete", true);
    };
    
    var deleteUserProfile = function(e) {
        confirmForm = $(this).closest("form")[0];
        $("#user_profile_prompt_delete .popup-inner-content-btn .btn")
                .click(confirmAction);
        openWindow("user_profile_prompt_delete", true);
    };

    var toggleServiceFees = function() {
        var t = $(this);
        var activate = true;

        if (t.hasClass('active')) {
            activate = false;
        }

        var url = '/action/manageGenData';
        url += '?id=' + t.attr('id');
        url += '&field12=' + activate;
        url += '&ajax=true';

        ajax(url, function(response) {
            if (response.indexOf('success') !== -1) {
                if (activate) {
                    t.addClass('active');
                    t.find('p').html(t.attr('data-deactivate'));
                } else {
                    t.removeClass('active');
                    t.find('p').html(t.attr('data-activate'));
                }
            }
        }, true);
    };
    
    var toggleAutoPayment = function () {
        var t = $(this);
        var id = t.attr("data-id");
        
        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id="+id;
        url += "&field13=" + (t.hasClass("active"));
        
        ajax(url, function(response){
            if(response.indexOf("success") !== -1){
                if(t.hasClass("active")){
                    t.find("p").text(t.attr("data-activate"));
                } else {
                    t.find("p").text(t.attr("data-deactivate"));                    
                }
                t.toggleClass("active");
            }
        }, true);
    };
    
    var init = function() {
        showMoreBtn = $(".btn-show-more");
        showMoreBtn.click(toggleDisplayElements);
        
        filterBtn = $(".user-filter");
        filterBtn.change(submitFilter);
        
        toggleAccountBtn = $(".toggle-account-activation");
        toggleAccountBtn.click(toggleAccountActivation);
        
        toggleProfileBtn = $(".toggle-profile-activation");
        toggleProfileBtn.click(toggleProfileActivation);

        submitManualOperationBtn = $('.submit-manual-op-btn');
        submitManualOperationBtn.click(submitManOpForm);

        deleteUserBtn = $('.delete-user-account');
        deleteUserBtn.click(deleteUser);

        deleteUserProfileBtn = $('.delete-user-profile');
        deleteUserProfileBtn.click(deleteUserProfile);

        toggleServiceFeesBtn = $('.toggle-service-fees-action');
        toggleServiceFeesBtn.click(toggleServiceFees);

        toggleAuto = $('.toggle-auto-balance');
        toggleAuto.click(toggleAutoPayment);
    };

    $(g).on("load", function() {
        if (d.getElementById("jsAdminUserAccounts")) {
            detectLanding();
            init();
        }
    });

})(jQuery, document, window);
			